import React from 'react'
import {withRouter} from 'react-router-dom'
import db from '../../../utils/firebase'
import './ReproductorSerie.scss'
import {map} from 'lodash'



 function ReproductorSerie(props) {
    
    const{ match, }= props
    const {params}=match
    const [dataSerie,setDataSerie] = React.useState(null)

 React.useEffect(()=>{
    if(params){
        db.collection("series").where("uuidPoster","==",params?.uuidPoster).get().then((response)=>{
            if(response.docs.length>0){
                const id = response.docs[0].id
                db.collection("series").doc(id).collection(params?.temporada).where("episodio","==",params?.episodio).get().then((response)=>{
                    if(response.docs.length>0){

                        const result = response.docs.map((doc)=>{
                            const data = doc.data()
                            return{
                                ...data
                            }
                        })
                        setDataSerie(...result)

                    }

                })
            }
        })
    }

 },[params])



   

    return (
        <div className="player" >
            <iframe
            allowFullScreen
            frameBorder="0"
            marginHeight="0"
            marginWidth="0"
            scrolling="none"
            src={dataSerie?.video}
            >
            </iframe>
        </div>
    )
}

export default withRouter(ReproductorSerie)
